import React from "react";
import { Typography, Paper, Box, Link } from "@mui/material";

function Refund() {
  return (
    <Box
      sx={{
        backgroundColor: "#f4f9ff",
        minHeight: "100vh",
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      {/* Header */}
      <div className="header">
        <img src="/logo.png" alt="Smart Parking Logo" className="logo" />
        <div className="heading-text">
          <br />
          <Typography variant="h4" className="title">
            Smart Parking App
          </Typography>
          <Typography variant="body2" className="caption">
            "Empowering Digital India .."
          </Typography>
        </div>
      </div>

     
      {/* Main Content */}
      <Paper
        elevation={3}
        sx={{
          p: 3,
          borderRadius: 4,
          backgroundColor: "#ffffff",
          maxWidth: 380,
          width: "87%",
          mx: "auto",
        }}
      >
        <Typography
          variant="h5"
          sx={{ mb: 2, fontWeight: "medium", color: "#1565c0" }}
        >
          Cancellation and Refund Policy
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          At Smart Parking App, we strive to provide a seamless parking experience. Please review our Cancellation and Refund Policy carefully before booking a parking slot.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          1. Cancellation Policy
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          Once a parking slot is booked through the Smart Parking App, cancellations are subject to the following terms:
          <ul>
            <li>A 100% cancellation fee is applicable for any cancellation of a parking slot booking. This means no money will be refunded for cancelled bookings.</li>
            <li>Cancellations must be initiated through the app or by contacting our support team before the parking slot's start time.</li>
          </ul>
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          2. Refund Policy
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          Due to the nature of our services, we do not offer refunds for cancelled parking slot bookings. The full amount paid will be retained as a cancellation fee, as outlined above.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          3. Exceptions
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          In rare cases, such as technical errors or service disruptions caused by the Smart Parking App, we may consider exceptions to this policy at our discretion. Please contact our support team to report such issues.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          4. Payment Processing
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          All payments are processed securely through Razorpay, our third-party payment gateway. Any disputes related to payment processing must be addressed directly with Razorpay, in accordance with their terms and policies.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          5. Changes to Policy
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          We reserve the right to update or modify this Cancellation and Refund Policy at any time. Any changes will be posted on this page, and continued use of the app constitutes acceptance of the updated policy.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          6. Contact Us
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          For any questions or concerns regarding this Cancellation and Refund Policy, please contact us at:
          <br />
          Email: <Link href="mailto:parkingsupport@apptech.co.in" sx={{ color: "#1565c0" }}>parkingsupport@apptech.co.in</Link>
          <br />
          Phone: <Link href="tel:+917001841402" sx={{ color: "#1565c0" }}>+91 7001841402</Link>
        </Typography>
      </Paper>
    </Box>
  );
}

export default Refund;